<template>
  <cta-button
    data-test-id="get-offer-cta"
    :event-category="ctaButtonData.event_category"
    :data="ctaButtonData"
    :href="ctaLink"
    :open-signup="openSignup"
    :open-login="openLogin"
    :is-block="false"
    :is-cta="false"
    :data-login-path="loginPath"
    :data-signup-path="signupPath"
  >
    {{ ctaCopy }}
  </cta-button>
</template>

<script>
import CtaButton from "@/shared/button"

/*
  Considerations when migrating this out of the web
  We have in the cta buttons classes that triggers some special ready stuff from legacy web:
  - js-pw-link: tracks the click event
  - js-open-signup-popup: Opens a popup instead of redirecting the user.

*/

export default {
  name: "CouponCta",
  components: {
    CtaButton
  },
  props: {
    ctaCopy: {
      type: String
    },
    ctaLink: {
      type: String
    },
    openSignup: {
      type: Boolean
    },
    openLogin: {
      type: Boolean
    },
    ctaButtonData: {
      type: Object,
      required: true
    },
    loginPath: {
      type: String
    },
    signupPath: {
      type: String
    }
  }
}
</script>
